module.exports = __webpack_public_path__ + "img/slider_1.f8c112d9.jpg";